import url from 'url';

export const isUrlAbsolute = (str = '') => {
  return !!url.parse(str).protocol;
};

export const getSecureUrl = (path, full) => {
  const newUrl = new URL(path, window.location.origin);
  newUrl.protocol = 'https:';
  return full ? newUrl : newUrl.href;
};

export const updateUrlParams = (url, params) => {
  if (!params) {
    return url;
  }

  const paramsString = params.replace('?', '');
  const precedingCharacter = url.includes('?') ? '&' : '?';
  return url + precedingCharacter + encodeURIComponent(paramsString);
};
